// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalV1MedicalBiResultSearchDefaultResponseData {
    static getAttributeTypeMap() {
        return MedicalV1MedicalBiResultSearchDefaultResponseData.attributeTypeMap;
    }
}
MedicalV1MedicalBiResultSearchDefaultResponseData.discriminator = undefined;
MedicalV1MedicalBiResultSearchDefaultResponseData.additionalProperties = false;
MedicalV1MedicalBiResultSearchDefaultResponseData.attributeTypeMap = [
    {
        "name": "results",
        "baseName": "results",
        "type": ""
    },
];
//# sourceMappingURL=medicalV1MedicalBiResultSearchDefaultResponseData.js.map